/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import { FontSizes, FontWeights, getTheme, IconButton } from "@fluentui/react";
import React from "react";
const theme = getTheme();
export const ShowPreview = (): JSX.Element => {
    return <div style={{ fontWeight: FontWeights.regular, fontSize: FontSizes.smallPlus, color: theme.palette.neutralPrimary }}>
        <h3>Find your documents inside your document libraries preview documents or create a shareble link</h3>
        <p> When open a folder a list of files appear</p>



        <div style={{ textAlign: 'center' }}>
            <img width='200' src={require('../../../assets/9.png')} />
        </div>
        <p>
            if you select this button <IconButton styles={{ root: { color: theme.palette.red, padding: 0, margin: 0, fontWeight: FontWeights.bold } }}
                title="Click Here To Create A shareable Link" iconProps={{ iconName: 'AddLink' }} disabled={false} checked={false} /> you can create a sheareble link for the file.
        </p>
        <p>
            if you select this button  <IconButton styles={{ root: { color: theme.palette.red, padding: 0, margin: 0, fontWeight: FontWeights.bold } }} title="Preview the document" iconProps={{ iconName: 'ComplianceAudit' }} disabled={false} checked={false} />
            a new browser will open with the preview of the selected document.  </p>



    </div>;
};
